import { PESANS_GET, STATUS_UPDATE, PESAN_DELETE } from './reduxConstant';

export const pesansGet = (pesans) => {
  return {
    type: PESANS_GET,
    payload: {
      pesans,
    },
  };
};

export const statusUpdate = (pesan) => {
  return {
    type: STATUS_UPDATE,
    payload: {
      pesan,
    },
  };
};

export const pesanDelete = (pesan) => {
  return {
    type: PESAN_DELETE,
    payload: {
      pesan,
    },
  };
};
